// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","cardFormMainArea":"_3A8P6kM7zliXLfpiLxwxLY","cardFormColumn":"_2e5yuVjzy2Ceg_9UPUsbPv","cardFormDescription":"_2UVqnAMi1Pb00jUf6p6Md9"};